import api from "./apiClient.js";

const endpoint = "subs";

export const newSub = (email) => {
	return api.post(endpoint, { email });
};

export const getAllSubs = (filter, page, limit) => {
	return api.get(endpoint, { page, limit, filter });
};

export const deleteSub = (id) => {
	return api.delete(endpoint + "/" + id);
};

export const deleteMySyb = (email) => {
	return api.post(endpoint + "/delete-my-sub", { email });
};
